export default __webpack_public_path__ + "media/exports/required/assets/img/images/brand_black-31c46d83b53d21eda00e085706bd8a9f.png";